module.exports = __webpack_public_path__ + "static/media/top-pc.23031f4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-pc.mp4
// module id = QcAp
// module chunks = 0